import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { colors } from '../styles';

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  backgroundColor: PropTypes.string
};
const CardContent = props => {
  const { className, children, backgroundColor = colors.pureWhite } = props;

  return (
    <StyledCardContent className={className} backgroundColor={backgroundColor}>
      {children}
    </StyledCardContent>
  );
};

CardContent.propTypes = propTypes;

const StyledCardContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 28px;
  height: 100%;
  background-color: ${({ backgroundColor }) => backgroundColor};
`;

export { CardContent };
